import styled from 'styled-components';

import { basic } from '../../theme/colors';

export const Address = styled.span<{ variant: 'primary' | 'secondary' }>`
  font-size: 12px;
  color: ${({ variant }) => (variant === 'primary' ? basic.haydenAccent : basic.haydenBrand)};
  margin-top: 1em;
  margin-bottom: 1em;
  display: block;
`;
